import { SettingsCard, ToggleField, NumberField } from "./fields";
import type { SettingsTabProps } from "../settings";

export default function KayitUyelik({ settings, update }: SettingsTabProps) {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
      <SettingsCard
        title="Kayıt Akışı"
        description="Yeni kullanıcıların platforma nasıl katılacağını yönetin."
      >
        <div className="space-y-3">
          <ToggleField
            label="Yeni kayıtlar açık"
            description="Kapatıldığında yeni hesap oluşturulamaz, mevcut kullanıcılar etkilenmez."
            checked={settings.registrationOpen}
            onChange={(v) => update({ registrationOpen: v })}
          />
          <ToggleField
            label="E-posta doğrulaması zorunlu"
            description="Kullanıcılar hesabını kullanmadan önce e-posta adresini doğrulamalıdır."
            checked={settings.emailVerification}
            onChange={(v) => update({ emailVerification: v })}
          />
          <ToggleField
            label="Öğretmen kaydına izin ver"
            description="Açıldığında öğretmenler kendi hesaplarını oluşturabilir. Kapalıyken yalnızca yönetici ekler."
            checked={settings.allowTeacherRegistration}
            onChange={(v) => update({ allowTeacherRegistration: v })}
          />
          <ToggleField
            label="Veli kaydına izin ver"
            description="Velilerin bağımsız hesap oluşturmasına izin verin."
            checked={settings.allowParentRegistration}
            onChange={(v) => update({ allowParentRegistration: v })}
          />
        </div>
      </SettingsCard>

      <SettingsCard
        title="Sınıf Kapasitesi"
        description="Canlı ders ve sınıf yapılandırması."
      >
        <NumberField
          label="Sınıf başına maksimum öğrenci"
          value={settings.maxStudentsPerClass}
          onChange={(v) => update({ maxStudentsPerClass: v })}
          min={1}
          max={500}
          hint="Bu sınıra ulaşan canlı derslere yeni öğrenci eklenemez."
        />
      </SettingsCard>
    </div>
  );
}